import { memo, useCallback, useMemo } from 'react';

import { Box, PressableIcon } from '@betty/moonlight';
import { matchRoutes, useLocation, useNavigate } from 'react-router';
import {
  CustomRouteHeaderPaths,
  // DisableBackButtonRoutes,
  RouteHeaderComponents,
} from './RouteHeader.constants';

function RouteHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const [routeHeaderPath] = matchRoutes(CustomRouteHeaderPaths, location) || [];
  // const centerLabel = matchRoutes(DisableBackButtonRoutes, location);

  const RouteHeaderComponent = useMemo(
    () => RouteHeaderComponents[routeHeaderPath?.route.path ?? ''],
    [routeHeaderPath],
  );

  const onBackPress = useCallback(() => {
    const hasKey = location.key !== 'default';
    const hasIdx = window.history.state?.idx > 0;
    const hasLen = window.history.length > 1;

    if (hasKey || hasIdx || hasLen) {
      navigate(-1);
    } else {
      navigate('/', { replace: true });
    }
  }, [location.key, navigate]);

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      gap="space-400"
      paddingHorizontal={{
        mobile: 'space-400',
        tablet: 'space-400',
        desktop: 'space-1000',
      }}
      paddingVertical="space-200"
    >
      <PressableIcon
        width="space-600"
        name="arrowBack"
        gradient="accentBackground"
        onPress={onBackPress}
      />
      <Box flex={1}>
        {RouteHeaderComponent ? <RouteHeaderComponent /> : null}
      </Box>
    </Box>
  );
}

export default memo(RouteHeader);
